<template>
    <div class="container-fluid settings">
        <p v-if="!loaded">
            Loading...
        </p>
        <form
            action=""
            @submit.prevent="saveSettings"
            v-if="loaded"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2>Company Details</h2>
                            <table class="form-table">
                                <tr>
                                    <th>Company Name:</th>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Company Name"
                                            v-model="settings.company_name"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="company_name"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Company Logo:</th>
                                    <td>
                                        <div class="input-group mb-3">
                                            <div class="custom-file">
                                                <input
                                                    type="file"
                                                    class="custom-file-input"
                                                    id="logo-upload"
                                                    @change="logoFileChanged"
                                                >
                                                <label
                                                    class="custom-file-label"
                                                    for="logo-upload"
                                                >Choose file</label>
                                            </div>
                                        </div>

                                        <div>
                                            <img
                                                v-if="settings.company_logo"
                                                :src="settings.company_logo"
                                                alt="Company Logo"
                                                class="settings__logo"
                                            >
                                            <button
                                                class="btn btn-sm btn-outline-warning"
                                                v-if="hasLogoChanged"
                                                @click.prevent="undoLogo"
                                            >
                                                Undo Logo
                                            </button>
                                            <button
                                                v-if="settings.company_logo"
                                                class="btn btn-sm btn-outline-danger"
                                                @click.prevent="clearLogo"
                                            >
                                                Clear Logo
                                            </button>
                                        </div>
                                        <error
                                            :errors="errors"
                                            name="company_logo"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Telephone Number:</th>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Telephone Number"
                                            v-model="settings.tel_number"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="tel_number"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Office Telephone Number:</th>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Office Telephone Number"
                                            v-model="settings.office_tel_number"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="office_tel_number"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Email Address:</th>
                                    <td>
                                        <input
                                            type="email"
                                            placeholder="Email Address"
                                            v-model="settings.email_address"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="email_address"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Website:</th>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="www.example.com"
                                            v-model="settings.website"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="website"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Address:</th>
                                    <td>
                                        <textarea
                                            rows="4"
                                            placeholder="Address..."
                                            v-model="settings.address"
                                            class="form-control"
                                        />
                                        <error
                                            :errors="errors"
                                            name="address"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Headquarters map:</th>
                                    <td>
                                        <p class="text-muted small mb-2">
                                            Coordinates are used as the Headquarters start on View Routes &amp; Order.
                                            Leave lat/lng empty to auto-geocode the address on save. Drag the marker to adjust.
                                        </p>
                                        <div class="form-row mb-2">
                                            <div class="col-sm-5">
                                                <label>Latitude</label>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    class="form-control"
                                                    v-model="settings.address_lat"
                                                    @change="syncHqMarkerFromSettings"
                                                >
                                                <error
                                                    :errors="errors"
                                                    name="address_lat"
                                                />
                                            </div>
                                            <div class="col-sm-5">
                                                <label>Longitude</label>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    class="form-control"
                                                    v-model="settings.address_lng"
                                                    @change="syncHqMarkerFromSettings"
                                                >
                                                <error
                                                    :errors="errors"
                                                    name="address_lng"
                                                />
                                            </div>
                                            <div class="col-sm-2 d-flex align-items-end">
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-outline-secondary"
                                                    @click.prevent="clearHqCoords"
                                                >
                                                    Clear coords
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            id="hq-settings-map"
                                            class="hq-settings-map"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2>Form Settings</h2>
                            <table class="form-table">
                                <tr>
                                    <th>BAFE Reg No:</th>
                                    <td>
                                        <input
                                            v-model="settings.bafe_reg"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="bafe_reg"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Footer Text:</th>
                                    <td>
                                        <textarea
                                            v-model="settings.forms_footer_text"
                                            rows="4"
                                            placeholder="Text displayed in left part of the footer on forms"
                                            class="form-control"
                                        />
                                        <error
                                            :errors="errors"
                                            name="forms_footer_text"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Footer Logos:</th>
                                    <td>
                                        <div class="input-group mb-3">
                                            <div class="custom-file">
                                                <input
                                                    type="file"
                                                    class="custom-file-input"
                                                    id="footer-upload"
                                                    @change="footerFileChanged"
                                                >
                                                <label
                                                    class="custom-file-label"
                                                    for="footer-upload"
                                                >Choose file</label>
                                            </div>
                                        </div>

                                        <div>
                                            <img
                                                v-if="settings.forms_footer_logos"
                                                :src="settings.forms_footer_logos"
                                                alt="Footer Right Logos"
                                                class="settings__logo"
                                            >
                                            <button
                                                class="btn btn-sm btn-outline-warning"
                                                v-if="hasFooterLogosChanged"
                                                @click.prevent="undoFooterLogos"
                                            >
                                                Undo Footer Logos
                                            </button>
                                            <button
                                                v-if="settings.forms_footer_logos"
                                                class="btn btn-sm btn-outline-danger"
                                                @click.prevent="clearFooterLogos"
                                            >
                                                Clear Footer Logos
                                            </button>
                                        </div>
                                        <error
                                            :errors="errors"
                                            name="forms_footer_logos"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2 name="email-settings">
                                Email Settings
                            </h2>
                            <table class="form-table">
                                <tr>
                                    <th>Email From</th>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="hello@example.com"
                                            v-model="settings.email_from"
                                            class="form-control"
                                        >
                                        <error
                                            :errors="errors"
                                            name="email_from"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Email Signature</th>
                                    <td>
                                        <quill-editor v-model="settings.email_signature" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2>Overtime Settings</h2>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Mon</th>
                                        <th>Tues</th>
                                        <th>Weds</th>
                                        <th>Thurs</th>
                                        <th>Fri</th>
                                        <th>Sat</th>
                                        <th>Sun</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>Standard Hours</th>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_mon"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_mon"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_tue"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_tue"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_wed"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_wed"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_thu"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_thu"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_fri"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_fri"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_sat"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_sat"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step=".25"
                                                min="0"
                                                max="24"
                                                v-model="settings.overtime_sun"
                                                class="form-control"
                                            >
                                            <error
                                                :errors="errors"
                                                name="overtime_sun"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2>Annual Leave Settings</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <label
                                class="label"
                                for="annual_leave_start_date"
                            >Annual Leave Start of Year:</label>
                            <date-time-picker-component
                                :options="{format: 'L'}"
                                v-model="settings.annual_leave_start_date"
                            />
                            <error
                                :errors="errors"
                                name="annual_leave_start_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <button class="btn btn-primary">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import ErrorComponent from "../../ErrorComponent";
import SystemSettingsService from "../../../services/SystemSettingsService";
import DateTimePickerComponent from "../../DateTimePickerComponent.vue";
import moment from "moment";
import { centerLatLng } from "../../../include/Map";
export default {
    components: {
        error: ErrorComponent,
        DateTimePickerComponent,
    },
    data() {
        return {
            settings: {},
            originalLogo: null,
            originalFooterLogos: null,
            loaded: false,
            errors: {},
            hqMap: undefined,
            hqMarker: undefined,
        };
    },

    computed: {
        hasLogoChanged() {
            return this.settings.company_logo !== this.originalLogo;
        },
        hasFooterLogosChanged() {
            return (
                this.settings.forms_footer_logos !== this.originalFooterLogos
            );
        },
    },

    mounted() {
        this.loadSettings();
    },

    methods: {
        ...mapMutations(["setInfoMessage", "setErrorMessage"]),
        loadSettings() {
            SystemSettingsService.loadSettings().then(({ data }) => {
                if (data) {
                    this.settings = {
                        ...data,
                        address_lat: data.address_lat !== undefined ? data.address_lat : null,
                        address_lng: data.address_lng !== undefined ? data.address_lng : null,
                        annual_leave_start_date: data.annual_leave_start_date
                            ? moment(data.annual_leave_start_date)
                            : moment(),
                    };
                    window.SystemSettings = data || {};
                    this.originalLogo = data.company_logo;
                    this.originalFooterLogos = data.forms_footer_logos;
                    this.loaded = true;
                    this.$nextTick(() => {
                        this.initHqMap();
                    });
                }
            });
        },

        saveSettings() {
            this.errors = {};
            const confirm = window.confirm(
                "Are you sure you want to save the current settings?"
            );
            if (!confirm) {
                return;
            }
            SystemSettingsService.saveSettings(this.settings)
                .then((res) => {
                    this.settings = {
                        ...res.data,
                        address_lat: res.data.address_lat !== undefined ? res.data.address_lat : null,
                        address_lng: res.data.address_lng !== undefined ? res.data.address_lng : null,
                        annual_leave_start_date: res.data.annual_leave_start_date
                            ? moment(res.data.annual_leave_start_date)
                            : this.settings.annual_leave_start_date,
                    };
                    window.SystemSettings = res.data;
                    this.originalLogo = res.data.company_logo;
                    this.originalFooterLogos = res.data.forms_footer_logos;
                    const address = this.settings.address;
                    const hasAddress = address && String(address).trim() !== '';
                    const hasCoords = this.hasHqCoords();
                    if (hasAddress && !hasCoords) {
                        this.setErrorMessage(
                            'Address saved, but coordinates could not be geocoded. Place the Headquarters pin on the map and save again.'
                        );
                    } else {
                        this.setInfoMessage('Settings saved');
                    }
                    this.$nextTick(() => {
                        this.syncHqMarkerFromSettings();
                    });
                })
                .catch((err) => {
                    this.setErrorMessage(
                        "Failed to save settings, please try again"
                    );
                    if (typeof err.response.data !== "undefined") {
                        this.errors = err.response.data.errors;
                        return;
                    }

                    throw err;
                });
        },
        initHqMap() {
            if (!window.google || !window.google.maps) {
                return;
            }
            const el = document.getElementById('hq-settings-map');
            if (!el) {
                return;
            }

            const hasCoords = this.hasHqCoords();
            const center = hasCoords
                ? {
                    lat: parseFloat(this.settings.address_lat),
                    lng: parseFloat(this.settings.address_lng),
                }
                : centerLatLng;

            this.hqMap = new window.google.maps.Map(el, {
                zoom: hasCoords ? 15 : 8,
                center: center,
            });

            this.hqMap.addListener('click', (event) => {
                this.settings.address_lat = event.latLng.lat();
                this.settings.address_lng = event.latLng.lng();
                this.syncHqMarkerFromSettings();
            });

            this.syncHqMarkerFromSettings();
        },
        hasHqCoords() {
            if (this.settings.address_lat === null || this.settings.address_lat === undefined || this.settings.address_lat === '') {
                return false;
            }
            if (this.settings.address_lng === null || this.settings.address_lng === undefined || this.settings.address_lng === '') {
                return false;
            }
            const lat = parseFloat(this.settings.address_lat);
            const lng = parseFloat(this.settings.address_lng);
            if (isNaN(lat) || isNaN(lng)) {
                return false;
            }
            return true;
        },
        syncHqMarkerFromSettings() {
            if (!this.hqMap || !window.google || !window.google.maps) {
                return;
            }
            if (this.hqMarker) {
                this.hqMarker.setMap(null);
                this.hqMarker = undefined;
            }
            if (!this.hasHqCoords()) {
                return;
            }
            const coords = {
                lat: parseFloat(this.settings.address_lat),
                lng: parseFloat(this.settings.address_lng),
            };
            this.hqMap.setCenter(coords);
            this.hqMap.setZoom(15);
            this.hqMarker = new window.google.maps.Marker({
                position: coords,
                map: this.hqMap,
                draggable: true,
                title: 'Headquarters',
            });
            this.hqMarker.addListener('dragend', (event) => {
                this.settings.address_lat = event.latLng.lat();
                this.settings.address_lng = event.latLng.lng();
            });
        },
        clearHqCoords() {
            this.settings.address_lat = null;
            this.settings.address_lng = null;
            this.syncHqMarkerFromSettings();
        },
        logoFileChanged($event) {
            let formData = new FormData();

            formData.append("file", $event.target.files[0]);

            window.axios
                .post(
                    "/api/upload",
                    formData,

                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                )
                .then((res) => {
                    this.settings.company_logo = res.data.full_url;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.setErrorMessage("Failed to upload, please try again");
                    throw err;
                });
        },
        footerFileChanged($event) {
            let formData = new FormData();

            formData.append("file", $event.target.files[0]);

            window.axios
                .post(
                    "/api/upload",
                    formData,

                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                )
                .then((res) => {
                    this.settings.forms_footer_logos = res.data.full_url;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.setErrorMessage("Failed to upload, please try again");
                    throw err;
                });
        },
        clearLogo() {
            this.settings.company_logo = null;
        },

        undoLogo() {
            this.settings.company_logo = this.originalLogo;
        },

        clearFooterLogos() {
            this.settings.forms_footer_logos = null;
        },

        undoFooterLogos() {
            this.settings.forms_footer_logos = this.originalFooterLogos;
        },
    },
};
</script>

<style scoped>
.hq-settings-map {
    width: 100%;
    height: 280px;
    margin-top: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/admin/SystemSettingsComponent.vue